module.exports = __webpack_public_path__ + "img/static__image.2fa3dbb5.png";